import { useEffect, useRef, useState } from "react";
import "./details.scss";
import LoadingOverlay from "../../components/loading/LoadingOverlay";

export default function Details() {
  const HOTEL_LINK =
    "https://www.ihg.com/holidayinnexpress/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99801505&icdv=99801505&qSlH=YKFKN&qCiD=10&qCiMy=052026&qCoD=12&qCoMy=052026&qGrpCd=RAL&setPMCookies=true&qSHBrC=EX&qDest=4355%20King%20Street%20East%2C%20Kitchener%2C%20ON%2C%20CA&showApp=true&adjustMonth=false&srb_u=1";

  const timelineBar = {
    src: `${process.env.PUBLIC_URL}/images/common/timelinebar.webp`,
    alt: "timeline bar",
  };
  const attirePalette = {
    src: `${process.env.PUBLIC_URL}/images/common/attire_palette.webp`,
    alt: "attire palette",
  };
  const qr = {
    src: `${process.env.PUBLIC_URL}/images/common/Hotel_QR.webp`,
    alt: "hotel qr code",
  };

  const WE_DO_MESSAGE =
    "Our ceremony will be held at the beautiful Basilica of Our Lady Immaculate. We kindly ask that you arrive at the church by 12:30 PM to allow yourself enough time for parking and getting settled. As it is a sacred place, we ask that you dress appropriately for the Mass.";
  const COCKTAIL_MESSAGE =
    "The estate grounds will open at four o’clock in the afternoon, with cocktail hour beginning at four thirty.";
  const DINNER_MESSAGE =
    "Our reception will be held at Roseville Estate in celebration of love, laughter, and our happily ever after! We are excited to party with everyone over drinks, dinner, and of course — dancing!";
  const ATTIRE_MESSAGE_2 =
    "Our lives have been so filled with colour, and we want the day to feel the same! We’d love for everyone to dress up and celebrate with us in style using the colour palette below as inspiration — think soft, colourful, summer hues.";
  const ATTIRE_MESSAGE_3 =
    "We ask that ladies refrain from wearing white, white/floral as well as light pink coloured dresses. For the gentlemen, we ask that you avoid wearing brown or tan suits!";
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Example: custom hook to check when your images load
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      {imagesLoaded && (
        <div
          className={`details margin-0 padding-bottom-60 ${
            imagesLoaded ? "fade-in" : ""
          }`}
        >
          <section className="details-banner text-center width-100 position-relative display-flex flex-column align-center justify-center">
            <div className="pearl-bg width-100 overflow-hidden position-absolute"></div>
            <h1 className="cormorant-500 font-size-8 letter-spacing-4 position-relative margin-top-0 text-medium">
              DETAILS
            </h1>
            <sub className="cormorant-400 font-size-4 letter-spacing-3 position-relative">
              EVERYTHING YOU NEED TO KNOW ABOUT THE LITTLE DETAILS TO PLAN FOR
              OUR BIG DAY
            </sub>
          </section>

          {/* ITINERARY */}
          <section
            className="itinerary text-center width-100 padding-top-12 padding-bottom-25"
            id="itinerary"
          >
            <h1 className="cormorant-500 text-medium font-size-8 letter-spacing-6">
              THE RALLOS WEDDING ITINERARY
            </h1>
            <sub className="cormorant-italic-500 font-size-5">
              Thursday, June 11th, 2026
            </sub>
            <div className="itinerary-cols justify-center width-100">
              <div className="left-col text-right">
                <div className="ceremony">
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-2">
                    CEREMONY
                  </h2>
                  <p className="cormorant-light-500 letter-spacing-2 font-size-3">
                    BASILICA OF OUR LADY IMMACULATE
                  </p>
                  <p className="cormorant-light-500 letter-spacing-2 font-size-3 margin-bottom-4">
                    28 NORFOLK ST, GUELPH, ON N1H 4H8
                  </p>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6878.71486655147!2d-80.25641147506988!3d43.54105394564672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b9ac169564329%3A0x3373f5e3b82b049b!2sBasilica%20of%20Our%20Lady%20Immaculate!5e0!3m2!1sen!2sca!4v1766079721785!5m2!1sen!2sca"
                    width="360"
                    height="270"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                <div className="reception">
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-2">
                    RECEPTION
                  </h2>
                  <p className="cormorant-light-500 letter-spacing-2 font-size-3">
                    ROSEVILLE ESTATE
                  </p>
                  <p className="cormorant-light-500 letter-spacing-2 font-size-3 margin-bottom-4">
                    2283 ROSEVILLE RD, CAMBRIDGE ON, N1R 5S3
                  </p>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1219.8837515189452!2d-80.419140357776!3d43.347975728222686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c74fcfdb74e1d%3A0x48c7b679f798f4be!2sRoseville%20Estate!5e0!3m2!1sen!2sca!4v1766080074111!5m2!1sen!2sca"
                    width="360"
                    height="270"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>

              {/* TIMELINE BAR */}
              <div className="margin-left-4 margin-right-4">
                <img
                  className="timeline-bar"
                  src={timelineBar.src}
                  alt={timelineBar.alt}
                  width="15"
                  height="756" // start collapsed, animate to 746
                  loading="lazy"
                />
              </div>

              {/* RIGHT COL */}
              <div className="right-col text-left">
                <section className="itinerary-mobile-header">
                  <h2 className="cormorant-500 letter-spacing-3 font-size-5 margin-top-0 margin-bottom-4">
                    SCHEDULE
                  </h2>
                </section>
                <section className="we-do">
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-0">
                    12:30 PM
                  </h2>
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-2">
                    WE DO
                  </h2>
                  <p className="cormorant-light-500">{WE_DO_MESSAGE}</p>
                </section>

                <section className="cocktails">
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-0">
                    4:30 PM
                  </h2>
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-2">
                    COCKTAILS & CANAPES
                  </h2>
                  <p className="cormorant-light-500">{COCKTAIL_MESSAGE}</p>
                </section>

                <section className="dinner">
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-0">
                    6:00 PM
                  </h2>
                  <h2 className="cormorant-light-500 letter-spacing-3 font-size-4 margin-bottom-2">
                    DINNER & DANCING
                  </h2>
                  <p className="cormorant-light-500">{DINNER_MESSAGE}</p>
                </section>
              </div>
            </div>
          </section>

          {/* ATTIRE */}
          <section className="attire text-center width-100 padding-top-12 padding-bottom-22 display-flex flex-column justify-center align-center">
            <div className="attire-message">
              <h1 className="cormorant-500 text-medium font-size-8 letter-spacing-6">
                ATTIRE
              </h1>
              <p className="margin-8 cormorant-light-500">
                The dress code is{" "}
                <strong className="cormorant-italic-700">formal.</strong>
              </p>
              <p className="margin-5 cormorant-light-500">{ATTIRE_MESSAGE_2}</p>
              <p className="margin-5 cormorant-light-500">{ATTIRE_MESSAGE_3}</p>
            </div>
            <div>
              <img
                className="width-100 height-100"
                src={attirePalette.src}
                alt={attirePalette.alt}
                loading="lazy"
              />
            </div>
          </section>

          {/* ACCOMMODATIONS */}
          <section className="accommodations text-center width-100 padding-top-12 padding-bottom-20 display-flex flex-column justify-center align-center">
            <h1 className="cormorant-500 text-medium font-size-8 letter-spacing-6">
              ACCOMMODATIONS
            </h1>
            <p className="cormorant-light-500 padding-top-4">
              We can’t wait to dine, drink & dance the night away with you!
              We’ve reserved a block of rooms to ensure your journey from the
              dance floor to dreamland is as easy as possible.
            </p>
            <p className="cormorant-light-500 padding-7">
              Get our discounted room rate{" "}
              <span className="underline">until May 11th</span> by clicking{" "}
              <a
                href={HOTEL_LINK}
                target="_blank"
                className="cormorant-italic-700 underline"
              >
                this link{" "}
              </a>
              or by using the group code{" "}
              <strong className="cormorant-italic-700">RAL</strong> under “Group
              Rate” in “Rate Preferences”.
              <br />
              You can also scan the QR code below:
            </p>
            <img
              src={qr.src}
              alt={qr.alt}
              width="220"
              height="220"
              loading="lazy"
            />
            <p className="cormorant-light-500 letter-spacing-1 padding-3 padding-top-7">
              HOLIDAY INN EXPRESS + SUITES <br />
              4355 KING ST EAST, KITCHENER, ON N2P 2E9
            </p>
            <p className="cormorant-light-500 padding-top-3 padding-bottom-10">
              You are welcome to leave your car parked overnight at Roseville
              Estate. Please retrieve your car by 11AM the following day.
            </p>
          </section>
        </div>
      )}
    </>
  );
}
